import { createContext, useState } from "react"
import API from "services/api"
// import _ from "lodash"

export const LegalContext = createContext({})

let tokenGoogle = localStorage.getItem("google_token")

const LegalProvider = (props) => {
	const [legalEvents, setLegalEvents] = useState([])
	const [legalEventDetail, setLegalEventDetail] = useState(null)

	const getFlegalbyID = (id) => {
		return API.getFlegalbyID(id)
			.then((res) => {
				const { data } = res
				setLegalEventDetail(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getFlegalbyParentID = (id) => {
		API.getFlegalbyParentID(id)
			.then((res) => {
				const { data } = res
				setLegalEvents(data)
			})
			.catch((err) => {
				console.log("err", err)
			})
	}

	const getFlegal = (params) => {
		API.getFlegal(params)
			.then((res) => {
				const { data } = res
				setLegalEvents(data)
			})
			.catch((err) => {
				console.log("err", err)
			})
	}

	const postfLegal = (data) => {
		API.postfLegal(data)
			.then((res) => {
				const { data } = res
				getFlegal()
			})
			.catch((err) => {
				console.log("err", err)
			})
	}

	const putManyfLegal = (data) => {
		API.putManyfLegal(data)
			.then((res) => {
				const { data } = res
				// getFlegal()
			})
			.catch((err) => {
				console.log("err", err)
			})
	}

	const putfLegal = (id, data) => {
		return API.putfLegal(id, data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				return err
			})
	}

	return (
		<LegalContext.Provider
			value={{
				legalEvents,
				legalEventDetail,
				setLegalEventDetail,

				getFlegalbyID,
				getFlegalbyParentID,
				getFlegal,
				postfLegal,
				putfLegal,
				putManyfLegal
			}}
			{...props}
		/>
	)
}

export default LegalProvider
